<!--问卷管理列表-->
<template>
  <div
    class="hbn-container"
    id="userInfo"
  >
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="QuestionnaireQuery"
            label-width="80px"
            label-position="right"
            size="mini"
          >
            <el-row :gutter="24">
              <!-- <el-col :span="10">
                <el-form-item label="创建时间">
                  <el-date-picker
                    v-model="QuestionnaireQuery.createTime"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    size="mini"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="问卷名称">
                  <el-input
                    id="DJBH"
                    v-model="QuestionnaireQuery.Title"
                    placeholder="问卷名称"
                    clearable
                    size="mini"
                  />
                </el-form-item>
              </el-col>
               <el-col :span="10">
                <el-form-item label="开始时间">
                  <el-date-picker
                    v-model="QuestionnaireQuery.StartDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    size="mini"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" v-if="show">
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="QuestionnaireQuery.Status"
                    class="m-2"
                    placeholder="状态"
                    size="mini"
                  >
                    <el-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="结束时间">
                  <el-date-picker
                    v-model="QuestionnaireQuery.EndDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    size="mini"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button
              size="mini"
              class="hbn-button-serach"
              @click="SearchOpt"
            >查找</el-button>
            <span
              class="control-collapse"
              @click="show = !show"
            >{{
              show ? "收起" : "展开"
            }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          @click="Opt('', 'New')"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <el-button
          class="custom-button"
          type="primary"
          style="width: 6rem"
          @click="BatchDel"
        >
          <i class="el-icon-delete custom-icon"></i>
          <span>批量删除</span>
        </el-button>
      </div>
      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            v-loading="pageData.loading"
            :data="pageData.tabledatas"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            :tooltip-config="{ enterable: true }"
            empty-text="没有更多数据了！"
            resizable
            stripe
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="selectAllChangeEvent"
            :checkbox-config="tableCheckboxConfig"
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>
            <template
              v-for="(item, key) in QuestionnaireList"
              :key="key"
            >
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              ></vxe-table-column>
            </template>
            <vxe-table-column
              width="240"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ row, rowIndex }">
                <el-button
                  v-show="row.status != 1"
                  type="text"
                  size="small"
                  @click="Opt(rowIndex, 'Edit')"
                >编辑</el-button>
                <!-- <el-popconfirm
                  title="是否要删除?"
                  @confirm="Opt(rowIndex, 'Del')"
                >
                  <template #reference>
                    <el-button
                      v-show="row.status == 0"
                      size="small"
                      type="text"
                    >删除</el-button>
                  </template>
                </el-popconfirm> -->
                <el-button
                  size="small"
                  type="text"
                  @click="Opt(rowIndex, 'Detail')"
                >查看</el-button>
                <el-button
                  size="small"
                  type="text"
                  @click="Opt(rowIndex, 'Del')"
                >删除</el-button>
                <el-button
                  v-show="row.status != 1"
                  type="text"
                  size="small"
                  @click="Opt(rowIndex, 'Audit')"
                >审核</el-button>
                <el-button
                  type="text"
                  size="small"
                  @click="Opt(rowIndex, 'QRCode')"
                >查看二维码</el-button>
                <!-- <el-button
                  v-show="row.status == 1"
                  type="text"
                  size="small"
                  @click="Opt(rowIndex, 'CancelAudit')"
                >取消审核</el-button> -->
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="pageData.currentPage"
            :page-size="pageData.currentSize"
            :page-sizes="pageData.pagesizes"
            :total="pageData.total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
            <template #left>
              <span class="page-left">
                <span>已选中 {{ checkendSum }}</span>
                <span
                  class="clear"
                  @click.prevent="clearRecords"
                >清空</span>
              </span>
            </template>
          </vxe-pager>
        </div>
      </div>
    </div>
  </div>
  <WXQRCode ref="qrcode"></WXQRCode>
</template>

<script>
import { QuestionnaireList } from "@assets/apiData/Questionnaire";
import {
  GetDataQuestionnaireList,
  DeleteQuestionnaire,
  ModifyQuestion,
  DeleteQuestions
} from "@api/Questionnaire";
import { ref, reactive, toRefs, onMounted } from "vue";
import { useRouter } from "vue-router";
// import XEUtils from "xe-utils";
import { ElMessage, ElMessageBox } from "element-plus";
import { dateFormat, dateCompare } from "@/util/utils.js";
import WXQRCode from "@comp/QRCode/WXQRCode.vue";
import Enumerable from "linq";

export default {
  name: "QuestionnaireList",
  components: {
    WXQRCode,
  },
  setup(props) {
    //基础数据
    const data = reactive({
      QuestionnaireQuery: {
        //查询区
        // createTime: "",
        StartDate: [],
        EndDate: [],
        Title: "",
        Status: "",
        sortField: {
          CreationTime: "desc",
        },
      },
      show: false, //展开收起状态
      selectedRow: null, //当前选中行
      multipleSelection: [], //多选数据
      statusList: [
        //状态选项
        {
          label: "全部",
          value: "",
        },
        {
          label: "已创建",
          value: 0,
        },
        {
          label: "已审核",
          value: 1,
        },
        {
          label: "已取消审核",
          value: 3,
        },
        {
          label: "已过期",
          value: 4,
        },
      ],
      tableCheckboxConfig: {
        checkMethod: ({ row }) => {
          // return row.status != 1
          return true;
        },
      }
    });
    //分页对象
    let pageData = reactive({
      loading: false,
      tabledatas: [],
      currentPage: 1,
      currentSize: 20,
      pagesizes: [20, 50, 100, 500],
      total: 0,
    });
    const multipleTable = ref(null);
    let checkendSum = ref(0); //选中记录数
    const router = useRouter(); //路由
    const qrcode = ref(null);

    //查询
    function SearchOpt() {
      pageData.loading = true;
      let PageQuery = {
        pageindex: pageData.currentPage,
        PageSize: pageData.currentSize,
        queryModel: data.QuestionnaireQuery,
      };
      PageQuery.queryModel.StartDate_s =  data.QuestionnaireQuery.StartDate != null && data.QuestionnaireQuery.StartDate.length == 2 && data.QuestionnaireQuery.StartDate[0] != ""
            ? dateFormat("YYYY-mm-dd",data.QuestionnaireQuery.StartDate[0])
            : null;
      PageQuery.queryModel.StartDate_e =  data.QuestionnaireQuery.StartDate != null && data.QuestionnaireQuery.StartDate.length == 2 && data.QuestionnaireQuery.StartDate[1] != ""
            ? dateFormat("YYYY-mm-dd",data.QuestionnaireQuery.StartDate[1])
            : null;
      PageQuery.queryModel.EndDate_s =  data.QuestionnaireQuery.EndDate != null && data.QuestionnaireQuery.EndDate.length == 2 && data.QuestionnaireQuery.EndDate[0] != ""
            ? dateFormat("YYYY-mm-dd",data.QuestionnaireQuery.EndDate[0])
            : null;
      PageQuery.queryModel.EndDate_e =  data.QuestionnaireQuery.EndDate != null && data.QuestionnaireQuery.EndDate.length == 2 && data.QuestionnaireQuery.EndDate[1] != ""
            ? dateFormat("YYYY-mm-dd",data.QuestionnaireQuery.EndDate[1])
            : null;
      GetDataQuestionnaireList(PageQuery)
        .then(({ entities, totalCount }) => {
          checkendSum.value = 0;
          pageData.tabledatas = entities;
          pageData.total = totalCount;
          pageData.loading = false;
        })
        .catch(({ mgessage }) => {
          pageData.loading = false;
          ElMessage.error("问卷列表查询失败" + mgessage);
          console.log("问卷列表查询失败", mgessage);
        });
    }
    //跳转页码
    function handlePageChange({ currentPage, pageSize }) {
      if (pageData.currentSize != pageSize) {
        pageData.currentPage = 1; //说明更改了每页展示条数，要从第一页进行展示
        pageData.currentSize = pageSize;
      } else {
        pageData.currentPage = currentPage;
      }
      SearchOpt();
    }
    //当前选中行
    const handleCurrentChange = ({ row }) => {
      data.selectedRow = row;
    };
    //多选
    const handleSelectionChange = ({ records }) => {
      data.multipleSelection = records;
      checkendSum.value = records.length;
    };
    //选中数量
    const selectAllChangeEvent = ({ checked, records }) => {
      data.multipleSelection = records;
      checkendSum.value = records.length;
    };
    //清除选中
    const clearRecords = () => {
      multipleTable.value.clearCheckboxRow();
      checkendSum.value = 0;
    };
    //操作节点
    const Opt = (rowIndex, name) => {
      let { tabledatas } = pageData;
      let id = 0;
      let data = null;
      if (name != "New") {
        id = tabledatas[rowIndex].id;
        data = tabledatas[rowIndex];
      }
      switch (name) {
        case "New": //新增
        case "Edit": //编辑
          router.replace({
            name: "问卷中心",
            params: {
              from: "QuestionnaireList",
              isReplace: true,
              senddata: JSON.stringify({ operation: name, mainId: id }),
            },
          });
          break;
        case "Detail": //查看
          router.replace({
            name: "问卷中心",
            params: {
              from: "QuestionnaireList",
              isReplace: true,
              senddata: JSON.stringify({ operation: name, mainId: id }),
            },
          });
          break;
        case "Del": //删除
          ElMessageBox.confirm(
            `您确认删除该问卷吗？删除后数据将不可恢复`,
            "提示",
            {
              cancelButtonClass: "cancelstyle",
              confirmButtonClass: "confirmstyle",
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              closeOnClickModal: false,
            }
          )
            .then(() => {
              DeleteQuestionnaire(id)
                .then((res) => {
                  ElMessage.success("删除成功！");
                  SearchOpt();
                })
                .catch((message) => {
                  ElMessage.error(message);
                });
            })
            .catch(() => {
              return;
            });
          break;
        case "Audit": //审核
          // var date1 = new Date();
          // var date2 = new Date(date1);
          // date2.setDate(date1.getDate() + 30);
          // data.startDate = dateFormat("YYYY-mm-dd", date1);
          // data.endDate = dateFormat("YYYY-mm-dd", date2);
          data.status = 1;
          ModifyQuestion(data)
            .then((res) => {
              ElMessage.success("审核成功！");
              SearchOpt();
            })
            .catch((message) => {
              ElMessage.error(message);
            });
          break;
        case "CancelAudit": //取消审核
          ElMessageBox.confirm(
            `您确认取消审核么，取消后小程序将不再展示该问卷`,
            "提示",
            {
              cancelButtonClass: "cancelstyle",
              confirmButtonClass: "confirmstyle",
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              closeOnClickModal: false,
            }
          )
            .then(() => {
              data.status = 3;
              ModifyQuestion(data)
                .then((res) => {
                  ElMessage.success("取消审核成功！");
                  SearchOpt();
                })
                .catch((message) => {
                  ElMessage.error(message);
                });
            })
            .catch(() => {
              return;
            });
          break;
        case "QRCode": // 生成小程序码
          let query = {
            id: data.id,
            title: data.title,
          };
          qrcode.value.getQRCode(
            "pages/home/takeQuestionnaireSurvey",
            data.title,
            query
          );
          break;
      }
    };
    //列表格式化
    const formatterData = ({ cellValue, row, column }) => {
      let head = JSON.parse(column.className);
      let format = head.format;
      let name = column.property;
      switch (format) {
        case "datetime": //日期
          cellValue =
            cellValue != null
              ? dateFormat("YYYY-mm-dd HH:MM:SS",cellValue)
              : "";
          break;
        case "date": //日期
          cellValue =
            cellValue != null
              ? dateFormat("YYYY-mm-dd",cellValue)
              : "";
          break;
        case "checkbox": //复选框
          cellValue = cellValue == "1" ? "是" : "否";
          break;
        case "dropdown": //下拉选项
          if (name == "status") {
            let date = dateFormat("YYYY-mm-dd", new Date());
            let endDate = row["endDate"];
            if(dateCompare(date,endDate,2)) {
              cellValue = "已过期"
            } else {
              let dropitem = data.statusList.find((item) => {
                return item.value+"" == cellValue+"";
              });
              if (dropitem) {
                cellValue = dropitem.label;
              }
            }
          }
          break;
      }
      return cellValue;
    };
    //批量删除
    const BatchDel = () => {
      if (data.multipleSelection.length == 0) {
        ElMessage.warning("请选择要删除的问卷");
        return;
      }
      ElMessageBox.confirm(`确定删除？`, "提示", {
        cancelButtonClass: "cancelstyle",
        confirmButtonClass: "confirmstyle",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      })
        .then(() => {
          let questionIds = Enumerable.from(data.multipleSelection)
            .select((ss) => ss.id)
            .toArray();
          DeleteQuestions(questionIds)
            .then((res) => {
              ElMessage.success("批量删除成功");
              SearchOpt();
            })
            .catch((message) => {
              ElMessage.error(message);
            });
        })
        .catch(() => {
          return;
        });
    }

    onMounted(() => {
      SearchOpt();
    });
    return {
      QuestionnaireList,
      pageData,
      multipleTable,
      checkendSum,
      ...toRefs(data),
      handleCurrentChange,
      handleSelectionChange,
      selectAllChangeEvent,
      clearRecords,
      handlePageChange,
      Opt,
      SearchOpt,
      formatterData,
      qrcode,
      BatchDel
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";

.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}

.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}

.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}

.page-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.operation {
  display: flex;
}

.pagination {
  margin: 0;
  width: 100%;
  /* position: absolute;
        bottom: 0; */
  background-color: #fff;
  z-index: 7;
  padding: 5px 0;
}
</style><style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";
</style>
<style scoped>
</style>
